/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import ICONS from "../../../../assets/Icons";
import SmallPopup from "../../../../components/_utils/CommonSmallPopup";
import PrimaryStepper from "../../../../components/_utils/CommonSteppers/PrimaryStepper";
import SVGComponent from "../../../../components/_utils/SVGComponent";
import { createReimburseAccount } from "../../../../redux/features/accounts/ReimburseAccount";
import {
  beneBankLookUp,
  beneVerifyThisBank,
  resetBankError,
  resetBeneVerifyThisGst,
} from "../../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import { getOwnerAccountIFSCDetails } from "../../../../redux/features/owner/ownerAllVerification/ownerAllVerification";
import {
  beneLookUp,
  resetBeneData,
  resetPANVerification,
  verifyThisPAN,
} from "../../../../redux/features/verifyPAN/verifyPAN";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import Validation from "../../../../utils/validation";
import CreateBank from "../CreateBank";
import CreateCategory from "../CreateCategory";
import CreateConfirm from "../CreateConfirm";
import CreateContact from "../CreateContact";
import CreatePan from "../CreatePan";

const id = (x) => x;
const CreateReimbursementAccount = () => {
  const scrollIt = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const userData = location.state;

  const steps = [
    "PAN details",
    "Bank details",
    "User and contact details",
    "Category, labels and recipients",
    "Confirm and create",
  ];

  const bankStatus = useSelector(
    (state) => state.beneAllVerification.verifyBank,
  );

  const { verifyPAN, beneLookData, verifyPANisLoading, beneLookError } =
    useSelector((state) => state.verify);

  const { beneLookLoading } = useSelector((s) => s.beneAllVerification);
  console.log(beneLookLoading);

  const { verifyBank, verifyBankisLoading } = useSelector(
    (state) => state.beneAllVerification,
  );

  const categories = useSelector(
    (state) => state.beneAllVerification.beneTransCategories.categories,
  ).filter((cat) => cat?.active === "Y");

  const categoriesConfirmPage = useSelector(
    (state) => state.beneAllVerification.beneTransCategories.categories,
  );

  const benebankLookData = useSelector(
    (state) => state.beneAllVerification.beneLookData,
  );

  const { services, isLoading } = useSelector((state) => state.refreshToken);

  const isBankError = useSelector(
    (state) => state.beneAllVerification.isBankError,
  );

  const { ownerAccIfscData, ownerAccIfscError, ownerAccIfscLoading } =
    useSelector((state) => state.ownerAllVerification);

  const [virtualAccount, setVirtualAccount] = useState(false);
  const [manualVirtualAccount, setManualVirtualAccount] = useState(false);
  const [nextButtonEnabled, BenEnableNextButton] = useState(true);
  const [lookupNext, setLookupNext] = useState(false);
  const [disableCreateNext, setDisableCreateNext] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [bankLookupNext, setBankLookupNext] = useState(false);
  const [hideBankBlock, setBankHideBlock] = useState(false);
  const [isButtonDisabled] = useState(false);
  const [selectedFields, setSelectedFields] = useState([]);
  const [verifiedPan, setVerifiedPan] = useState(null);
  const [selectedLabelsCreate, setSelectedLabelsCreate] = useState([]);
  const [contactBol, setContactBol] = useState({
    email: "",
    contact: "",
    accountname: "",
  });
  const [bankUserInfo, setBankUserInfo] = useState([]);
  const [GSTStatus, setGSTStatus] = useState(null);
  const [bankVerificationStatus, setBankVerificationStatus] = useState(false);
  const [payload, setPayload] = useState({
    bank_account: userData?.bank_acc_no || "",
    ifsc_code: userData?.ifsc_code || "",
    contact_no: userData?.contact_no || "",
    email_id: userData?.email_id || "",
    gstin: userData?.gstin_no || "",
    name: "",
    categories: userData?.category || "",
    panNumber: userData?.pan || "",
    gst_org_name: "",
    account_name: "",
    labels: [],
    recipient_email: "",
    linked_user_id: "",
    userName: "",
    userId: "",
    virtual: "",
  });

  const [showModalPopup, setShowModalPopup] = useState(false);
  const [showAlertCategories, setShowAlertCategories] = useState(false);
  const [selectedValue, setSelectedValue] = useState("legalname");
  const [accountNameValidation, setAccountNameValidation] = useState(true);
  const [selectedCatFields, setSelectedCatFields] = useState([]);
  const [direction, setDirection] = useState(null);
  const [removeClassName, setRemoveClassName] = useState(true);
  const [createDisabled, setCreateDisabled] = useState(false);
  const [recipients, setRecipients] = useState([]);
  const [createRecipient, setCreateRecipient] = useState([]);
  const [remPan, setRemPan] = useState();
  const [newData, setNewData] = useState({
    gstin: "",
  });

  const animationClass =
    direction === "next" ? "animate-slide-next" : "animate-slide-prev";

  const bene_acc_id = userData?.id;

  const dataReceiveFromContact = (data) => {
    setContactBol(data);
  };

  const handleOpen = () => {
    setShowModalPopup(true);
  };

  const handleCreateAccount = async () => {
    if (createDisabled) return;
    setCreateDisabled(true);
    try {
      let updatedPayload = { ...payload, navigate };
      if (
        selectedFields.length === categoriesConfirmPage.length ||
        selectedFields.length === GlobalConfiguration?.lengthCheckZero
      ) {
        updatedPayload.categoriesConfirmPage = null;
      } else {
        updatedPayload = {
          ...updatedPayload,
          categoriesConfirmPage: selectedFields.toString(),
        };
      }

      const data = await dispatch(
        createReimburseAccount(updatedPayload),
      ).unwrap();

      const accountId = data.reimbursement_accounts[0].id;

      if (data?.status === true) {
        navigate(
          `/reimbursement_account_dashboard/create_reimbursement_account/success/${accountId}`,

          {
            replace: true,
          },
        );
      }
    } catch (error) {
      navigate(
        "/reimbursement_account_dashboard/create_reimbursement_account/error",
        {
          replace: true,
          state: error?.response?.data?.error || error?.response?.data?.errors,
        },
      );
      return error;
    } finally {
      setCreateDisabled(false);
    }
  };

  const bankData = useSelector(
    (state) => state.beneAllVerification.beneLookData,
  );

  let haveApproved = beneLookData?.beneficiary_accounts.find((val) => {
    return val?.approval_status === "approved";
  });

  let havePending = beneLookData?.beneficiary_accounts.find((val) => {
    return val?.approval_status === "pending";
  });
  let haveBankApproved = bankData?.beneficiary_accounts.find((val) => {
    return val?.approval_status === "approved";
  });

  let haveBankPending = bankData?.beneficiary_accounts.find((val) => {
    return val?.approval_status === "pending";
  });

  const handleMainCreate = () => {
    if (benebankLookData?.status === undefined && beneLookError === true) {
      handleCreateAccount();
      sessionStorage.setItem("Create ReimburseAcc Fresh PAN", false);
      sessionStorage.setItem("Create ReimburseAcc Fresh Bank", false);
      sessionStorage.removeItem(
        "Create ReimburseAcc Approve and Decline status",
      );
    } else if (
      !haveApproved &&
      !havePending &&
      !haveBankApproved &&
      !haveBankPending
    ) {
      handleCreateAccount();
      sessionStorage.setItem("Create ReimburseAcc Fresh PAN", false);
      sessionStorage.setItem("Create ReimburseAcc Fresh Bank", false);
      sessionStorage.removeItem(
        "Create ReimburseAcc Approve and Decline status",
      );
    } else {
      handleOpen();
      sessionStorage.removeItem(
        "Create ReimburseAcc Approve and Decline status",
      );
    }
  };
  useEffect(() => {
    setRemPan(payload.panNumber);
  }, [payload.panNumber]);

  const handleEnterKeyPress = (e) => {
    if (e.key === "Enter" && activeStep === 3) {
      handleMainCreate();
    }
    if (e.code === "Space") {
      setShowModalPopup(false);
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleEnterKeyPress);
    return () => {
      document.removeEventListener("keydown", handleEnterKeyPress);
    };
  }, []);

  useEffect(() => {
    if (!verifyPANisLoading) {
      if (verifyPAN?.status === true) {
        setVerifiedPan(true);
        dispatch(beneLookUp({ pan_number: payload.panNumber }));
        setPayload({
          ...payload,
          legalName: verifyPAN?.pan_details?.full_name,
          account_name: verifyPAN?.pan_details?.full_name,
        });
      } else if (
        verifyPAN?.status === false &&
        payload?.panNumber.length === GlobalConfiguration.panLength
      ) {
        setVerifiedPan(false);
      }
    }
  }, [verifyPAN]);

  // useEffect(() => {
  //   if (!verifyBankisLoading) {
  //     if (verifyBank?.status === true) {
  //       setBankAccountName(true);
  //       setBankAccountName(verifyBank?.verification_details[0]?.full_name);
  //     }
  //   }
  // }, [verifyBank]);

  useEffect(() => {
    dispatch(resetPANVerification());
    setVerifiedPan(null);
  }, []);

  const isIFSCValid =
    payload?.ifsc_code?.length === GlobalConfiguration.ifscLength &&
    Validation.ifscRegex.test(payload?.ifsc_code);

  useEffect(() => {
    if (payload.ifsc_code?.length < GlobalConfiguration.ifscLength) {
      dispatch(resetBankError());
    }
    if (
      payload.bank_account?.length < GlobalConfiguration.accountnormalLength
    ) {
      const obj = { ...payload, ifsc_code: "" };
      setPayload(obj);
    }
    if (
      payload.bank_account?.length === GlobalConfiguration.lengthCheckZero &&
      payload.ifsc_code?.length > GlobalConfiguration.lengthCheckZero
    ) {
      const newObj = { ...payload, ifsc_code: "" };
      setPayload(newObj);
      BenEnableNextButton(true);
      dispatch(resetBankError());
    }
    if (
      payload.bank_account?.length >= GlobalConfiguration.accountnormalLength &&
      payload.ifsc_code?.length === GlobalConfiguration.ifscLength &&
      Validation.ifscRegex.test(payload.ifsc_code)
    ) {
      dispatch(
        beneVerifyThisBank({
          ifsc_code: payload.ifsc_code,
          bank_account: payload.bank_account,
          legal_name: payload.legalName,
          navigate: navigate,
        }),
      );
      dispatch(
        beneBankLookUp({
          ifsc: payload.ifsc_code,
          bank_account_no: payload.bank_account,
        }),
      );
      dispatch(
        getOwnerAccountIFSCDetails({
          search_string: payload?.ifsc_code,
          page_no: GlobalConfiguration?.lengthCheckOne,
          page_size: GlobalConfiguration?.filterResults,
        }),
      );
    }
    if (
      createRecipient &&
      createRecipient.length > GlobalConfiguration.lengthCheckZero
    ) {
      setPayload((prev) => ({
        ...prev,
        recipient_email: createRecipient.join(","),
      }));
    } else {
      setPayload((prev) => {
        const updated = { ...prev };
        delete updated.recipient_email;
        return updated;
      });
    }
  }, [
    payload.ifsc_code,
    payload.bank_account,
    payload.legalName,
    createRecipient,
  ]);

  useEffect(() => {
    if (benebankLookData?.status && activeStep === 1) {
      BenEnableNextButton(true);
    }
  }, [benebankLookData]);

  useEffect(() => {
    if (
      location?.state?.bank_acc_no &&
      location?.state?.ifsc_code &&
      location?.state?.type === "switch_account"
    ) {
      BenEnableNextButton(true);
      setBankLookupNext(true);
      return;
    }

    if (!beneLookLoading) {
      setTimeout(() => {
        if (isIFSCValid && !isBankError) {
          if (benebankLookData?.status) {
            setBankLookupNext(false);
          } else if (!verifyBankisLoading && verifyBank?.status) {
            setBankLookupNext(true);
          }
        }
      }, 0);
    }
  }, [
    beneLookLoading,
    benebankLookData,
    isBankError,
    isIFSCValid,
    virtualAccount,
    verifyBankisLoading,
    verifyBank,
  ]);

  useEffect(() => {
    setSelectedValue("legalname");
  }, [payload.panNumber]);
  const renderCreateAccount = () => {
    switch (activeStep) {
      case 0:
        return (
          <CreatePan
            verifiedPan={verifiedPan}
            panNumber={payload.panNumber}
            handlePanChange={handlePanChange}
            panDetails={verifyPAN?.pan_details}
            beneLookData={beneLookData}
            beneLookLoading={beneLookLoading}
            lookupNext={lookupNext}
            setLookupNext={setLookupNext}
            BenEnableNextButton={BenEnableNextButton}
            verifyPANisLoading={verifyPANisLoading}
            setIsArchived={id}
            setIsApproved={id}
            setIsDennied={id}
            setIsPending={id}
            disableCreateNext={disableCreateNext}
            setDisableCreateNext={setDisableCreateNext}
            beneLookError={beneLookError}
            setPayload={setPayload}
            payload={payload}
            handleDeSelectConfirm={handleDeSelectConfirm}
            GSTStatus={GSTStatus}
            setGSTStatus={setGSTStatus}
            setNewData={setNewData}
            type={userData?.type}
          />
        );
      case 1:
        return (
          <CreateBank
            isButtonDisabled={isButtonDisabled}
            setBankIsArchived={id}
            setBankIsApproved={id}
            bankLookupNext={bankLookupNext}
            setBankLookupNext={setBankLookupNext}
            setBankIsPending={id}
            setBankIsDennied={id}
            nextButtonEnabled={nextButtonEnabled}
            BenEnableNextButton={BenEnableNextButton}
            activeStep={activeStep}
            payload={payload}
            setPayload={setPayload}
            hideBankBlock={hideBankBlock}
            setBankHideBlock={setBankHideBlock}
            setBankUserInfo={setBankUserInfo}
            bankVerificationStatus={bankVerificationStatus}
            setBankVerificationStatus={setBankVerificationStatus}
            isIFSCValid={isIFSCValid}
            isBankError={isBankError}
            virtualAccount={virtualAccount}
            setVirtualAccount={setVirtualAccount}
            manualVirtualAccount={manualVirtualAccount}
            setManualVirtualAccount={setManualVirtualAccount}
            ownerAccIfscData={ownerAccIfscData}
            ownerAccIfscError={ownerAccIfscError}
            type={userData?.type}
          />
        );
      case 2:
        return (
          <CreateContact
            payload={payload}
            setPayload={setPayload}
            categories={categories}
            onSelectFieldsChange={handleSelectFieldsChange}
            BenEnableNextButton={BenEnableNextButton}
            parentCreateBen={dataReceiveFromContact}
            activeStep={activeStep}
            selectedValue={selectedValue}
            setSelectedValue={setSelectedValue}
            accountNameValidation={accountNameValidation}
            setAccountNameValidation={setAccountNameValidation}
            selectedCatFields={selectedCatFields}
          />
        );
      case 3:
        return (
          <CreateCategory
            payload={payload}
            selectedLabelsCreate={selectedLabelsCreate}
            setSelectedLabelsCreate={setSelectedLabelsCreate}
            setPayload={setPayload}
            categories={categories}
            onSelectFieldsChange={handleSelectFieldsChange}
            parentCreateBen={dataReceiveFromContact}
            selectedCatFields={selectedCatFields}
            setSelectedCatFields={setSelectedCatFields}
            createRecipient={createRecipient}
            setCreateRecipient={setCreateRecipient}
            recipients={recipients}
            setRecipients={setRecipients}
            type={userData?.type}
          />
        );
      case 4:
        return (
          <CreateConfirm
            payload={payload}
            selectedFields={selectedFields}
            setShowModalPopup={setShowModalPopup}
            showModalPopup={showModalPopup}
            bankUserInfo={bankUserInfo}
            recipients={createRecipient}
            remPan={remPan}
            setRemPan={setRemPan}
            manualVirtualAccount={manualVirtualAccount}
            type={userData?.type}
            bene_acc_id={bene_acc_id}
          />
        );
      default:
        return null;
    }
  };

  useEffect(() => {
    if (!isLoading && services != null) {
      if (services?.includes("RUAccount") || services?.includes("Admin")) {
      } else {
        navigate("/feature_not_assigned", {
          state: { unavailableService: "RUAccount" },
        });
      }
    }
  }, [services, isLoading]);
  const isPanVerified = verifiedPan === true;

  const hasAssociatedAccounts = beneLookData?.status === true;

  const noAssociatedAccounts = beneLookError === true;

  const isGstEmpty =
    payload?.gstin?.length === GlobalConfiguration.lengthCheckZero;

  const isGstVerified =
    payload?.gstin?.length === GlobalConfiguration.gstLength &&
    GSTStatus === true;

  const isGstInvalid =
    payload?.gstin?.length > GlobalConfiguration.lengthCheckZero &&
    !isGstVerified;

  const shouldEnableNextButtonFirstStepper =
    isPanVerified &&
    ((noAssociatedAccounts && (isGstEmpty || isGstVerified)) ||
      (hasAssociatedAccounts && lookupNext)) &&
    !isGstInvalid;

  const isBankStatusValid = bankStatus?.status === true;
  const isBankAccountValid =
    payload?.bank_account?.length > GlobalConfiguration.lengthCheckZero;
  const isIfscCodeValid =
    payload?.ifsc_code?.length === GlobalConfiguration.ifscLength;
  const isVerifyBankValid = verifyBank?.status === true;

  const shouldEnableNextButtonSecondStepper =
    benebankLookData === null
      ? isBankStatusValid &&
        isBankAccountValid &&
        isIfscCodeValid &&
        isVerifyBankValid
      : isBankStatusValid &&
        isBankAccountValid &&
        isIfscCodeValid &&
        isVerifyBankValid &&
        bankLookupNext === true;

  const isContactValid = contactBol.contact === true;
  const isEmailValid = contactBol.email === true;
  const isAccountNameValid = contactBol.accountname === true;

  const shouldEnableNextButtonThirdStepper =
    isContactValid && isEmailValid && isAccountNameValid;

  useEffect(() => {
    if (
      activeStep === GlobalConfiguration.lengthCheckZero &&
      !beneLookLoading
    ) {
      BenEnableNextButton(!shouldEnableNextButtonFirstStepper);
    } else if (activeStep === GlobalConfiguration.lengthCheckOne) {
      BenEnableNextButton(
        !(shouldEnableNextButtonSecondStepper && bankLookupNext),
      );
    } else if (activeStep === GlobalConfiguration.lengthCheckTwo) {
      BenEnableNextButton(!shouldEnableNextButtonThirdStepper);
    } else if (activeStep === GlobalConfiguration.lengthCheckThree) {
      BenEnableNextButton(!true);
    } else if (activeStep === GlobalConfiguration.lengthCheckFour) {
      // setRemPan(payload.panNumber);
      BenEnableNextButton(false);
    }
  }, [
    activeStep,
    bankStatus?.status,
    contactBol?.contact,
    contactBol?.email,
    payload?.bank_account,
    payload?.ifsc_code,
    payload?.gstin,
    verifiedPan,
    verifyBank?.status,
    bankLookupNext,
    beneLookData,
    lookupNext,
    shouldEnableNextButtonFirstStepper,
    shouldEnableNextButtonSecondStepper,
    shouldEnableNextButtonThirdStepper,
    beneLookLoading,
    selectedFields,
    categories,
    showAlertCategories,
    manualVirtualAccount,
  ]);

  const handleKeyDown = (event) => {
    if (event.target.tagName === "INPUT") {
      // if (event.key === "Tab") {
      //   event.preventDefault();
      // }
    } else if (
      event.key === "ArrowLeft" ||
      event.key === "ArrowRight" ||
      event.key === "Tab" ||
      event.key === " "
    ) {
      event.preventDefault();
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const handleNext = () => {
    if (
      activeStep === 3 &&
      selectedFields?.length === categories?.length &&
      !showAlertCategories
    ) {
      if (userData?.type === "switch_account") {
        setShowAlertCategories(false);
      } else {
        setShowAlertCategories(true);
      }
      setSelectedLabelsCreate(selectedLabelsCreate || []);
    } else if (activeStep === 4) {
      handleMainCreate();
    } else {
      // setButtonDisabled(true);
      setShowAlertCategories(false);
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      setDirection("next");
      setRemoveClassName(false);
      setTimeout(() => {
        setRemoveClassName(true);
      }, 1000);
      // setTimeout(() => {
      //   setButtonDisabled(false);
      // }, 500);
    }
  };

  const handleBack = () => {
    if (activeStep === 0) {
      navigate(-1);
      return;
    }
    // setButtonDisabled(true);
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    setDirection("previous");
    setRemoveClassName(false);
    setTimeout(() => {
      setRemoveClassName(true);
    }, 1000);
  };

  const handleDeSelectConfirm = () => {
    setLookupNext(false);
    BenEnableNextButton(true);
  };

  const handleSelectFieldsChange = (selectedFields) => {
    setSelectedFields(selectedFields);
  };

  const handlePanChange = (e) => {
    const inputPan = e.target.value.toUpperCase();

    if (!Validation.alphanumericRegex.test(inputPan)) {
      return;
    }

    if (inputPan.length > 10) {
      return;
    }
    if (
      !Validation.panRegex.test(inputPan) &&
      inputPan.length === GlobalConfiguration.panLength
    ) {
      setVerifiedPan(false);
      dispatch(resetBeneData());
    } else if (inputPan.length === GlobalConfiguration.panLength) {
      dispatch(verifyThisPAN({ pan_number: inputPan, showToast: false }));
      setGSTStatus(null);
    } else {
      setVerifiedPan(null);
      BenEnableNextButton(true);
      setLookupNext(false);
    }
    setPayload({
      ...payload,
      panNumber: inputPan,
      gstin: userData?.gstin || "",
    });
    setDisableCreateNext(false);
    setLookupNext(false);
    dispatch(resetBeneVerifyThisGst());
  };

  const accountHome = () => {
    navigate(GlobalConfiguration?.navigate_back);
  };

  useEffect(() => {
    if (newData.gstin?.length !== GlobalConfiguration?.gstLength) {
      setLookupNext(false);
    }
  }, [payload.gstin]);

  useEffect(() => {
    scrollIt.current.scrollTop = GlobalConfiguration?.lengthCheckZero;
  }, [activeStep]);

  useEffect(() => {
    if (location?.state?.pan && location?.state?.type === "switch_account") {
      handlePanChange({ target: { value: location.state.pan } });
      setDisableCreateNext(true);
      setLookupNext(true);
    }
  }, [location?.state?.type]);

  const dataArray = [
    {
      previousText: "Cancel",
      nextText: "Next",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--text-primary)",
      previousDisableBgColor: "var(--primary-nav-act)",
      nextDisableBgColor: "var(--text-disabled)",
      nextEnableTextColor: "var(--primary-bg)",
      nextDisableTextColor: "var(--text-primary)",
      previousEnableTextColor: "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      nextIsLoading: false,
      nextIsEnabled: !nextButtonEnabled,
      stepperText: steps[0],
    },
    {
      previousText: "Previous",
      nextText: "Next",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--text-primary)",
      previousDisableBgColor: "var(--primary-nav-act)",
      nextDisableBgColor: "var(--text-disabled)",
      nextDisableTextColor: "var(--text-primary)",
      nextEnableTextColor: "var(--primary-bg)",
      previousEnableTextColor: "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      nextIsLoading: false,
      nextIsEnabled:
        (!nextButtonEnabled &&
          !verifyBankisLoading &&
          !ownerAccIfscLoading &&
          !beneLookLoading) ||
        manualVirtualAccount,
      stepperText: steps[1],
    },
    {
      previousText: "Previous",
      nextText: "Next",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--text-primary)",
      previousDisableBgColor: "var(--primary-nav-act)",
      nextDisableBgColor: "var(--text-disabled)",
      nextDisableTextColor: "var(--text-primary)",
      nextEnableTextColor: "var(--primary-bg)",
      previousEnableTextColor: "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      nextIsLoading: false,
      nextIsEnabled: !nextButtonEnabled,
      stepperText: steps[2],
    },
    {
      previousText: "Previous",
      nextText: "Next",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--text-primary)",
      previousDisableBgColor: "var(--primary-nav-act)",
      nextDisableBgColor: "var(--text-disabled)",
      nextDisableTextColor: "var(--text-primary)",
      nextEnableTextColor: "var(--primary-bg)",
      previousEnableTextColor: "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      nextIsLoading: false,
      nextIsEnabled: !nextButtonEnabled,
      stepperText: steps[3],
    },
    {
      previousText: "Previous",
      nextText: "Confirm",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--positive-act)",
      previousDisableBgColor: "var(--primary-nav-act)",
      nextDisableBgColor: "var(--text-disabled)",
      nextDisableTextColor: "var(--text-primary)",
      nextEnableTextColor: "var(--text-primary)",
      previousEnableTextColor: "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      nextIsLoading: false,
      nextIsEnabled: !nextButtonEnabled && !createDisabled,
      stepperText: steps[4],
    },
  ];

  return (
    <div className="w-width-full flex flex-col items-center h-full-height bg-primary-bg">
      <div className="w-width-full">
        <div className="h-navbar-height hidden Qsmd:block"></div>
        <div className="h-[calc(var(--navbar-breadcrumb-height)-var(--navbar-height))] my-margin-sm Qsmd:my-margin-base"></div>
      </div>
      {showAlertCategories && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
          <SmallPopup
            headerTitle={"It is unsafe to proceed"}
            headerFontWeight="semibold"
            headerFontColor="negative-act"
            textSize="font-md"
            headerWithIcon="https://q2pay.in/new_assets/common/dashboard/alert.svg"
            subtext="Assigning all categories to a single account is highly unsafe.
                  It is recommended to limit the number of categories assigned
                  to the account."
            btnOneText="Cancel"
            btnOneBtnType="button"
            btnOneEnabledBgColor="transparent"
            btnOneHandleFunction={() => setShowAlertCategories(false)}
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText="Proceed"
            btnTwoBtnType="button"
            btnTwoHandleFunction={() => handleNext()}
            // btnTwoEnabledBgColor="var(--positive-act)"
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={false}
            btnTwoHoverOption="black"
          />
        </div>
      )}

      <div className="bene_crt_reminder_header flex justify-center items-end !bottom-bottom-base Qsmd:min-h-stepper-height rounded-t-border-radius-md Qmd:relative Qlg:bg-transparent bg-primary-nav rounded-b-border-radius-md w-screen fixed Qsmd:top-top-base left-left-base z-z-index-overlay">
        <PrimaryStepper
          activeStep={activeStep}
          handleForwardAction={handleNext}
          handleBackwardAction={handleBack}
          dataArray={dataArray}
        />
      </div>

      <div className="flex items-center w-width-full bg-primary-nav p-padding-sm fixed left-left-base top-top-base z-z-index-header Qsmd:hidden">
        <div
          className="w-icon-sm h-icon-sm cursor-pointer"
          onClick={accountHome}
        >
          <SVGComponent
            url={ICONS.ARROW_LEFT_WHITE}
            color="var(--text-primary)"
          />
        </div>

        <div className=" flex flex-col pl-padding-md">
          <p className=" text-font-md font-sans text-text-primary">
            {" "}
            Reimbursement Account
          </p>
          {activeStep === 0 && (
            <p className="text-font-xs font-sans text-text-primary">
              {" "}
              PAN details
            </p>
          )}
          {activeStep === 1 && (
            <p className="text-font-xs font-sans text-text-primary">
              {" "}
              Bank details
            </p>
          )}
          {activeStep === 2 && (
            <p className="text-font-xs font-sans text-text-primary">
              {" "}
              User and contact details
            </p>
          )}
          {activeStep === 3 && (
            <p className="text-font-xs font-sans text-text-primary">
              {" "}
              Category, labels and recipients
            </p>
          )}
          {activeStep === 4 && (
            <p className="text-font-xs font-sans text-text-primary">
              {" "}
              Confirm and create account
            </p>
          )}
        </div>
      </div>

      <>
        <div className="max-w-tab-width-normal mx-auto overflow-hidden h-full flex flex-col items-center relative w-width-full">
          <div className="h-stepper-moble-height w-width-full hidden flex-shrink-0"></div>
          <div
            ref={scrollIt}
            className={`w-width-full h-full overflow-x-hidden Qsmd:pt-padding-lg Qsmd:pb-padding-md pt-padding-base no-scrollbar ${
              activeStep === GlobalConfiguration.lengthCheckZero &&
              direction === "next"
                ? ""
                : removeClassName === true
                  ? ""
                  : animationClass
            }`}
          >
            {renderCreateAccount()}
          </div>
        </div>
      </>

      <div className="h-stepper-moble-height flex-shrink-0 w-width-full Qsmd:hidden block"></div>
    </div>
  );
};

export default CreateReimbursementAccount;
